import {useEffect} from 'react';
import {create} from 'zustand';
import {VERIFICATION_METHODS, type VerificationMethod} from '@chekin/api';

export type ContactsVerificationStep = 'input' | 'code';

export type ContactsVerificationState = {
  channel: VerificationMethod;
  step: ContactsVerificationStep;
  hasError: boolean;
};

const IDLE: ContactsVerificationState = {
  channel: VERIFICATION_METHODS.email,
  step: 'input',
  hasError: false,
};

type Store = ContactsVerificationState & {
  set: (state: ContactsVerificationState) => void;
};

export const useContactsVerificationStore = create<Store>(set => ({
  ...IDLE,
  set: state => set(state),
}));

export function usePublishContactsVerificationState(state: ContactsVerificationState) {
  const publish = useContactsVerificationStore(store => store.set);
  const {channel, step, hasError} = state;

  useEffect(() => {
    publish({channel, step, hasError});
    return () => publish(IDLE);
  }, [publish, channel, step, hasError]);
}
